import React, { useState } from 'react';
import { useDrawer } from '@context/DrawerContext';
import DatePicker from 'react-datepicker';
import Button from '@solar/common/Button/Button';
import { addMonths, subMonths } from 'date-fns';

interface HelpFormDatePickerDrawerProps {
  selectedDate?: Date;
  onDateChange?: (date?: Date) => void;
}

export default function HelpFormDatePickerDrawer({
  selectedDate,
  onDateChange,
}: HelpFormDatePickerDrawerProps) {
  const { closeDrawer } = useDrawer();
  const [tempDate, setTempDate] = useState<Date | undefined>(selectedDate);

  const handleDateChange = (newDate: Date | null) => {
    setTempDate(newDate || undefined);
  };

  const handleApply = () => {
    if (onDateChange) {
      onDateChange(tempDate);
    }
    closeDrawer();
  };

  const handleCancel = () => {
    if (onDateChange) {
      onDateChange(selectedDate);
    }
    closeDrawer();
  };

  return (
    <div className="flex flex-col h-full text-solar-primary pt-spacing-xs w-full">
      <div
        id="home-page-search-experiment"
        className="flex-1 mt-spacing-lg px-10 overflow-y-auto relative"
      >
        <DatePicker
          selected={tempDate}
          onChange={handleDateChange}
          className="font-rp-basetica text-solar-primary no-shadow w-full"
          inline
          dateFormat="yyyy-MM-dd"
          minDate={subMonths(new Date(), 6)}
          maxDate={addMonths(new Date(), 6)}
          fixedHeight
        />
      </div>

      <div className="border-t border-solar-secondary flex flex-row flex-shrink-0 items-center justify-between mt-spacing-lg p-spacing-md space-x-spacing-md sticky bottom-0 bg-solar-surface-primary">
        <Button color="transparent" size="lg" onClick={handleCancel} fullWidth>
          Cancel
        </Button>

        <Button color="primarySRP" size="lg" onClick={handleApply} fullWidth>
          Select
        </Button>
      </div>
    </div>
  );
}
